import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { C } from "@/theme";
import { useAuth } from "@/auth";
import { Field, OptionSelector, FormScreen } from "@/ui";

const ACTIVITY_TYPES = ["Meeting", "Club Ride", "Event", "Training Day", "Committee", "Admin", "Other"];

export default function LogActivity() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { user } = useAuth();
  const trainersQ = useQuery({ queryKey: ["trainers"], queryFn: () => api.get("/trainers") });
  const myId = (trainersQ.data ?? []).find((t) => t.name === user?.name)?.id ?? "";

  const [activityType, setActivityType] = useState("Meeting");
  const [hours, setHours] = useState("");
  const [date, setDate] = useState("");
  const [notes, setNotes] = useState("");

  const save = useMutation({
    mutationFn: () => api.post("/tutor-activities", { trainer_id: myId, activity_type: activityType, hours: parseFloat(hours) || 0, date: date || undefined, notes }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["tutor-activities"] }); navigate(-1); },
  });
  const disabled = !myId || !(parseFloat(hours) > 0);

  return (
    <FormScreen title="Log Activity" saveLabel="Save" onClose={() => navigate(-1)} onSave={() => save.mutate()} saving={save.isPending} saveDisabled={disabled}>
      <OptionSelector label="Activity type" options={ACTIVITY_TYPES} value={activityType} onChange={setActivityType} testID="activity-type" />
      <Field label="Hours" value={hours} onChange={setHours} type="number" placeholder="e.g. 2.5" testID="activity-hours" />
      <Field label="Date" value={date} onChange={setDate} type="date" testID="activity-date" />
      <Field label="Notes (optional)" value={notes} onChange={setNotes} multiline testID="activity-notes" />
      <p style={{ color: C.muted }} className="text-[13px] italic">These hours are tracked separately from your coaching (run) hours.</p>
    </FormScreen>
  );
}
